<div *ngIf="!bphChange.hide && !confChange.showDetails && !bphChange.showDetails && !globalConf.showDetails"
     [ngClass]="bphChange.error[selectedLanguage] ? 'hasError' : 'noError'"
     class="{{bphChange.error_class}} hide_{{bphChange.show}}"
     style="margin-bottom: 1.34375em">

  <div class="formLabel">
    <ng-container *ngIf="confChange.condensedLabel && confChange.condensedLabel[selectedLanguage]">
      <span style="font-weight: bolder" [innerHTML]="confChange.condensedLabel[selectedLanguage]"></span><br>
    </ng-container>
    <span *ngIf="confChange.isRequired" style="color: red">* </span>
    <span *ngIf="confChange.label" [innerHTML]="confChange.label[selectedLanguage]"></span>
    <span *ngIf="confChange.hasTooltip" style="padding-top: 10px;">
      <mat-icon matTooltip="{{confChange.tooltipText[selectedLanguage]}}" matTooltipClass="tooltip">help_outline</mat-icon>
    </span>
    <span *ngIf="confChange.hasDialog" style="padding-top: 10px;">
      <mat-icon (click)="openDialog(confChange)"
                style="cursor: pointer; vertical-align: middle !important; margin-top: -2px !important;">help_outline</mat-icon>
    </span>
  </div>

  <span *ngIf="bphChange.error[selectedLanguage]"
          class="formFieldError">{{ bphChange.error[selectedLanguage]}}</span>


  <form [formGroup]="eligibilityForm">
  <table class="angular-table">
    <thead>
    <tr>
      <th colspan="2" class="table-title-cell">
        <h2 class="align-center">{{confChange.label[selectedLanguage]}}</h2>
      </th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let category of eligibilityCategories">
      <tr class="category-header-row">
        <td colspan="2" class="category-header">
          {{ category.name }}
        </td>
      </tr>

      <tr *ngFor="let criterion of category.criteria; let i = index" class="draggable-tr">
        <td class="align-start padding-left">
          <span class="criterion-name">{{ criterion.name }}</span>
        </td>
        <td class="align-end">

          <mat-radio-group
            [value]="getCriterionValue(category.id,criterion.id)"
            [formControlName]="criterion.id"
            (change)="changeValueEvent($event, category.id, criterion)"
            class="horizontal-radios">
            <mat-radio-button value="true">{{getTranslatedValue('ecase.taxonomy.1.1')}}</mat-radio-button>
            <mat-radio-button value="false">{{getTranslatedValue('ecase.taxonomy.1.2')}}</mat-radio-button>
          </mat-radio-group>

        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
  </form>
</div>


